// extracted by mini-css-extract-plugin
export default {"root":"i7S98_"};